import React from "react";
import { useTranslation } from "react-i18next";

function View(props) {
  const { t } = useTranslation("auth");
  return (
    <div id="login-wrapper">
      <img
        className="max-w-32 m-auto block my-6"
        src="/img/new-icons/MSB-full-logo-extended.svg"
        alt={t("termsOfUse.logoAlt")}
      />
      <div className="max-w-96 m-auto">
        <h1 className="mb-4">{t("termsOfUse.title")}</h1>
        <p>{t("termsOfUse.paragraph1")}</p>
        <p>{t("termsOfUse.paragraph2")}</p>
        <p>{t("termsOfUse.paragraph3")}</p>
        <p>{t("termsOfUse.paragraph4")}</p>
        <p>{t("termsOfUse.paragraph5")}</p>
        <p>
          {t("termsOfUse.paragraph6")}{" "}
          <a href="mailto:info@mystrengthbook.com">
            {t("termsOfUse.contactUs")}
          </a>
          .
        </p>
      </div>
    </div>
  );
}

const TermsOfUse = (app) => {
  app.get("/terms-of-use", ({ res }) => (res.body = <View />));
};

export default TermsOfUse;
